import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { order, isKiteUser } = {}) => {
  const isDescOrder = order === 'desc';
  const color = isKiteUser ? theme.palette.primary1 : theme.palette.primary2;

  return {
    root: {
      cursor: 'pointer',

      '& path:nth-child(2)': {
        fill: isDescOrder ? color : theme.palette.grey2,
      },

      '& path:nth-child(3)': {
        fill: isDescOrder ? theme.palette.grey2 : color,
      },
    },
  };
});
